import React from 'react'

const WT5000 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Power Analyzers And Power Meters </span>
                        <i class="fa fa-angle-right"></i>
                        <span>WT5000 </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/wt5.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>WT5000:</h2>
                        <p className="mbot25">
                            Number of Input Channels: 1-7 <br />
                            Basic Power Accuracy (60 Hz): 0.01% or Reading + 0.02% of Range<br />
                            Bandwidth: DC to 1 MHz
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WT5000
